import { Container } from "@mui/material";
import { useEffect, useState } from "react";
import LicensesTable from "../../components/LicensesTable/LicensesTable";
import PublicNavbar from "../../components/Navigation/PublicNavbar";
import { Licenses } from "../../types/model/licenses/licenses";

export default function LicensesPage() {
  const [data, setData] = useState<Licenses | null>(null);

  useEffect(() => {
    fetch("/licenses.json")
      .then((response) => response.json())
      .then((data) => setData(data));
  }, []);

  return (
    <>
      <PublicNavbar />

      <Container maxWidth="lg" sx={{ mt: 12, pb: 4 }}>
        <LicensesTable data={data} />
      </Container>
    </>
  );
}
